$(document).ready(function ($) {
    const menu = $('.header-mobileMenu');
    const menuBtn = $('#menuOpenBtn');
    const preloader = $('.center');
    preloader.fadeOut();

    function menuItemToggle() {
        const item = $('.header-menu > .menu-item-has-children');
        item.on('click', function (e) {
            if (e.target !== this)
                return;
            $(this).toggleClass('active')
            const subMenu = $(this).find('.sub-menu');
            subMenu.eq(0).stop().toggleClass('opened')
        })

    }

    function menuOpen() {
        menuBtn.click(function () {
            menu.toggleClass('opened');
        })
    }


    function modal_interaction() {
        $('.modal-trigger').on('click', function () {
            $(this).siblings('.modal').addClass('opened');
            $(this).siblings('.modal').css('display', 'flex');
            $('body').css('overflow', 'hidden');
        })

        $('.close-trigger').on('click', function () {
            $('.modal').removeClass('opened');
            $('.modal').css('display', 'none');
            $('body').css('overflow', 'auto');
        })

        $('.modal-overlay').on('click', () => {
            $('body').css('overflow', 'auto');
            $('.modal').css('display', 'none');
            $('.modal').removeClass('opened');
        })

        $(document).on('keydown', (e) => {
            if (e.keyCode === 27) $('.close-trigger').click();
        })

    }


    menuOpen();
    menuItemToggle();
    modal_interaction();


    $('.packages-card-disable').on('click', function (e) {
        e.preventDefault();
    })

    $('.menu-item:not(.menu-item-has-children) a').on('click', function () {
        $('.header-mobileMenu').removeClass('opened')
    })
})

const btn = $('#top');

$(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
        btn.addClass('show');
    } else {
        btn.removeClass('show');
    }
});

btn.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, '300');
});

$(document).on('click', 'a', function (event) {
    const elemId = $.attr(this, 'href').replace(/\//g, "");
    if (!!$(elemId).length && $(this).attr('href').length > 1) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $(elemId).offset().top - 50
        }, 500);
    }
});


function toggleElement(elementToClick) {
    $(elementToClick).click(function() {
        $(this).toggleClass('active');
        $(this).siblings('.spoiler-body').slideToggle(300);
        $(this).find('.check').toggle();
        $(this).find('.hide').toggle();
    });
}

toggleElement('.spoiler-header');


document.querySelectorAll('.faq-question').forEach((button) => {
    button.addEventListener('click', () => {
        const answer = button.nextElementSibling;

        document.querySelectorAll('.faq-answer.visible').forEach((openAnswer) => {
            if (openAnswer !== answer) {
                openAnswer.classList.remove('visible');
                openAnswer.previousElementSibling.classList.remove('active');
            }
        });

        button.classList.toggle('active');
        answer.classList.toggle('visible');
    });
});